import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import BatchMotionJobPreviewModal, {
  batchMotionFileCanPreview,
} from '../../shared/BatchMotionJobPreviewModal';
import { useStore } from '../assetLibraryStore';

const ASSET_LIBRARY_STOCK_MOTION_PREVIEW_MODAL_MAX_WIDTH = 720;

export default function AssetLibraryStockMotionPreviewModal() {
  const store = useStore();
  const { stockMotionPreview } = store.state;
  const isOpen = Boolean(stockMotionPreview.motionId);

  const previewFile =
    stockMotionPreview.motionId && stockMotionPreview.bvhURL
      ? {
          id: stockMotionPreview.motionId,
          name: stockMotionPreview.title ?? stockMotionPreview.motionId,
          status: 'COMPLETED',
          bvhURL: stockMotionPreview.bvhURL,
        }
      : null;

  if (isOpen && stockMotionPreview.status === 'pending') {
    return (
      <Modal
        open
        onOpenChange={(nextOpen) => {
          if (!nextOpen) {
            store.closeStockMotionPreview();
          }
        }}
        title="Loading preview…"
        maxWidth={ASSET_LIBRARY_STOCK_MOTION_PREVIEW_MODAL_MAX_WIDTH}
        fullscreenOnMobile
      >
        <div className="flex justify-center p-12">
          <Loading />
        </div>
      </Modal>
    );
  }

  if (isOpen && stockMotionPreview.status === 'error') {
    return (
      <Modal
        open
        onOpenChange={(nextOpen) => {
          if (!nextOpen) {
            store.closeStockMotionPreview();
          }
        }}
        title="Unable to load preview"
        maxWidth={480}
        footer={
          <Button
            type="button"
            variant="secondary"
            size="lg"
            onClick={() => store.closeStockMotionPreview()}
          >
            Close
          </Button>
        }
      >
        <Text token="14/medium" className="text-secondary text-pretty">
          {stockMotionPreview.error ??
            'Something went wrong while loading this preview.'}
        </Text>
      </Modal>
    );
  }

  if (
    previewFile &&
    batchMotionFileCanPreview(previewFile) &&
    stockMotionPreview.status === 'ready'
  ) {
    return (
      <BatchMotionJobPreviewModal
        open={isOpen}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) {
            store.closeStockMotionPreview();
          }
        }}
        jobId={previewFile.id}
        jobTitle={previewFile.name}
        batchMotionNumber={1}
        totalMotionsInBatch={1}
        bvhURL={previewFile.bvhURL ?? ''}
        exportSettings={null}
        hideDownloadUI
        modalMaxWidth={ASSET_LIBRARY_STOCK_MOTION_PREVIEW_MODAL_MAX_WIDTH}
      />
    );
  }

  return null;
}
